import { gql } from '@apollo/client';

export const CLOSE_DISCOUNT_MUTATION = gql`
  mutation CloseDiscount($id: Int!) {
    p {
      closeDiscount(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
